// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__oXg0-","small":"Button_small__eTCbp","medium":"Button_medium__W+MSj","large":"Button_large__yaa3u"};